import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import 'mapbox-gl/dist/mapbox-gl.css';
import configureStore from 'reduxConfig';
import './styles/fonts.css';

let div = document.createElement('div');
div.setAttribute('id', 'app');
document.body.appendChild(div);

const mountNode = document.getElementById('app');
const store = configureStore();

const myRender = Component => {
  return ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <Component />
      </Provider>
    </AppContainer>,
    mountNode
  );
}

myRender(App);

if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept('./app', () => {
    const NextApp = require('./app').default;
    render(NextApp);
  });
}
